import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import {LanguagesService} from '@/brief-hub/brief/LanguagesService';
    import {LanguageResource} from '@/common/api/api-raw-types';
    import {ref, watch} from 'vue';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    interface Props {
        readonly languagesService: LanguagesService;
        readonly modelValue: LanguageResource[];
    }

    interface AutoCompleteEvent {
        originalEvent: Event;
        value: LanguageResource;
    }

    interface AutoCompleteCompleteEvent {
        originalEvent: Event;
        query: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageField',
  props: {
    languagesService: {},
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

    const {$msg} = useGlobalProperties();
    const props = __props;
    const emit = __emit;
    const languages = ref<LanguageResource[]>([]);
    const query = ref<LanguageResource | null>(null);
    const suggestions = ref<LanguageResource[]>([]);

    function init() {
        if (props.modelValue) {
            languages.value = props.modelValue;
        }
    }

    async function handleComplete(event: AutoCompleteCompleteEvent) {
        if (event.query) {
            const [data, error] = await props.languagesService.search(event.query);
            if (!data || error) {
                pushVJoySnackbar({
                    props: {
                        message: $msg('customer.brief.error.unknown'),
                        level: 'error',
                    },
                });
            } else {
                suggestions.value = data;
            }
        }
    }

    function handleSelectedLanguage(event: AutoCompleteEvent) {
        if (!event.value) {
            return;
        }
        const alreadyPresent = languages.value.find((language) => language.code === event.value.code);

        if (!alreadyPresent) {
            languages.value.push(event.value);
            query.value = null;
        }
    }

    function removeLanguage(index: number): void {
        languages.value.splice(index, 1);
    }

    init();

    watch(languages, () => emit('update:modelValue', languages));

return (_ctx: any,_cache: any) => {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_VJoyTag = _resolveComponent("VJoyTag")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VJoyWrapper, {
      direction: "column",
      align: "stretch"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_VJoyLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.skills.languages.title.v2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_AutoComplete, {
            modelValue: query.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
            suggestions: suggestions.value,
            optionLabel: "label",
            forceSelection: "",
            placeholder: _unref($msg)('customer.brief.exec.form.freelancer.skills.languages.placeholder'),
            "data-testid": "language-field",
            onOptionSelect: handleSelectedLanguage,
            onComplete: handleComplete
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" > ")
            ])),
            _: 1
          }, 8, ["modelValue", "suggestions", "placeholder"])
        ]),
        _createVNode(_component_VJoyWrapper, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language, index) => {
              return (_openBlock(), _createBlock(_component_VJoyTag, {
                key: `language-${language.code}`,
                label: language.label,
                removable: "",
                variant: "secondary",
                onRemove: ($event: any) => (removeLanguage(index))
              }, null, 8, ["label", "onRemove"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})